import { Component, ViewChild, ViewContainerRef, AfterViewChecked, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from './shared/service/language/language.service';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { ModalService } from './shared/service/modal/modal.service';
import { IconSetService } from '@coreui/icons-angular';

import { iconSubset } from '../assets/icons/icon-subset';
import { CsToasterComponent } from '@shared/component/toster/toster.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule, CsToasterComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewChecked {
  private translate = inject(TranslateService);
  private languageService = inject(LanguageService);
  private modalService = inject(ModalService);
  private route = inject(ActivatedRoute);

  @ViewChild('modalContainer', { read: ViewContainerRef })
  modalContainer!: ViewContainerRef;

  textTranslatedByPipe = '';
  private modalOpened = false;
  readonly #iconSetService = inject(IconSetService);

  constructor() {
    const languageService = this.languageService;

    this.translate.setDefaultLang(languageService.getTranslationLanguage());
    // Eagerly start the translation HTTP fetch during bootstrap so the JSON file has the
    // maximum possible time to arrive before any component calls translate.instant().
    // setDefaultLang registers the fallback but does NOT trigger an HTTP request; use() does.
    this.translate.use(languageService.getTranslationLanguage());
    this.#iconSetService.icons = { ...iconSubset };
  }

  ngAfterViewChecked(): void {
    if (!this.modalOpened && this.modalContainer) {
      this.checkUrlForMfaSettings(this.route.snapshot.fragment);
    }
  }

  checkUrlForMfaSettings(fragment: string | null) {
    if (fragment === 'mfa-settings') {
      this.modalService.openMfaSettingsModal(this.modalContainer);
      this.modalOpened = true;
    }
  }

  switchLanguage(language: string): void {
    this.translate.use(language);
    this.updateTranslatedText();
  }

  private updateTranslatedText(): void {
    this.translate.get('TRANSLATED_BY_COMPONENT').subscribe((translation: string) => {
      this.textTranslatedByPipe = translation;
    });
  }
}
